import React from 'react';
import { principles } from '@/content/principles';

const PrinciplesList = () => (
  <ol className="reveal border-t border-rule">
    {principles.map((p, i) => (
      <li key={p.title} className="grid grid-cols-[2.5rem_1fr] gap-4 border-b border-rule py-6">
        <span className="pt-2 font-mono text-xs tracking-[0.18em]">
          <span className="gold-shine">0{i + 1}</span>
        </span>
        <div>
          <h3 className="mb-1.5 text-3xl leading-tight">{p.title}</h3>
          <p className="text-mist">{p.body}</p>
        </div>
      </li>
    ))}
  </ol>
);

export default PrinciplesList;
